import { useEffect, useMemo, useState } from 'react';
import { apiFetch } from './api';

export const DEFAULT_STATUSES = [
  { key: 'collection', label: 'Collection', color_bg: '#daf0dc', color_fg: '#2d6a31', include_in_collection: true, include_in_care_rounds: true, include_in_data_health: true, is_wishlist: false, is_archived: false },
  { key: 'propagation', label: 'Propagation Stock', color_bg: '#fef3cd', color_fg: '#856404', include_in_collection: true, include_in_care_rounds: true, include_in_data_health: true, is_wishlist: false, is_archived: false },
  { key: 'available', label: 'Available', color_bg: '#cce5ff', color_fg: '#004085', include_in_collection: true, include_in_care_rounds: true, include_in_data_health: true, is_wishlist: false, is_archived: false },
  { key: 'loaned_in', label: 'Loaned In', color_bg: '#e0f7fa', color_fg: '#00695c', include_in_collection: true, include_in_care_rounds: true, include_in_data_health: true, is_wishlist: false, is_archived: false },
  { key: 'loaned_out', label: 'Loaned Out', color_bg: '#fff3e0', color_fg: '#e65100', include_in_collection: true, include_in_care_rounds: false, include_in_data_health: false, is_wishlist: false, is_archived: false },
  { key: 'wishlist', label: 'Wishlist', color_bg: '#e8dff0', color_fg: '#6a2d8a', include_in_collection: false, include_in_care_rounds: false, include_in_data_health: false, is_wishlist: true, is_archived: false },
  { key: 'sold', label: 'Sold', color_bg: '#f0f0f0', color_fg: '#666666', include_in_collection: false, include_in_care_rounds: false, include_in_data_health: false, is_wishlist: false, is_archived: true },
  { key: 'gifted', label: 'Gifted', color_bg: '#fce4ec', color_fg: '#ad1457', include_in_collection: false, include_in_care_rounds: false, include_in_data_health: false, is_wishlist: false, is_archived: true },
  { key: 'swapped', label: 'Swapped', color_bg: '#e6f4ea', color_fg: '#137333', include_in_collection: false, include_in_care_rounds: false, include_in_data_health: false, is_wishlist: false, is_archived: true },
  { key: 'deceased', label: 'Deceased', color_bg: '#f5d5d5', color_fg: '#8a2d2d', include_in_collection: false, include_in_care_rounds: false, include_in_data_health: false, is_wishlist: false, is_archived: true },
];

export function usePlantStatuses() {
  const [statuses, setStatuses] = useState(DEFAULT_STATUSES);

  useEffect(() => {
    let cancelled = false;
    apiFetch('/plant-statuses')
      .then(res => res.ok ? res.json() : Promise.reject(new Error('Failed to load statuses')))
      .then(data => {
        if (!cancelled && Array.isArray(data) && data.length) setStatuses(data);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return statuses;
}

export function useStatusMeta() {
  const statuses = usePlantStatuses();
  return useMemo(() => {
    const byKey = Object.fromEntries(statuses.map(status => [status.key, status]));
    return { statuses, byKey };
  }, [statuses]);
}

export function formatStatus(status, byKey = {}) {
  return byKey[status]?.label || DEFAULT_STATUSES.find(s => s.key === status)?.label || (status || '').replaceAll('_', ' ');
}

export function statusStyle(status, byKey = {}) {
  const meta = byKey[status] || DEFAULT_STATUSES.find(s => s.key === status);
  return meta ? { backgroundColor: meta.color_bg, color: meta.color_fg } : undefined;
}
